import SmartLink from 'src/components/smart-link/smart-link';
import { renderDateLong } from 'src/utils/date-time';
import Complaint from 'src/pages/complaint/complaint';
import { ComplaintEntityType } from 'src/constants/complaint-entity-type';
import css from './news-card.module.scss';
import { NewsListItem } from './interfaces';

interface NewsCardProps {
  news: NewsListItem;
}

export default function NewsCard({ news }: Readonly<NewsCardProps>) {
  const renderComplaintWrapper = (
    complaint: React.ReactNode,
    onMouseEnter: (e: React.MouseEvent) => void,
    onMouseLeave: (e: React.MouseEvent) => void
  ) => (
    <SmartLink href={news.slug} className={css.card}>
      <div className={css.content}>
        {news.imgUrl && (
          <picture // NOSONAR
            title={news.title}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}>
            <img src={news.imgUrl} alt={news.title} />
            {complaint}
          </picture>
        )}
        <header>
          <p className={css.publishedDate}>{renderDateLong(news.publishedAt)}</p>
          <h3>{news.title}</h3>
        </header>
      </div>
    </SmartLink>
  );

  return (
    <Complaint
      entityId={news.id}
      entityType={ComplaintEntityType.NEWS}
      targetTitle={news.title}
      wrapper={renderComplaintWrapper}
    />
  );
}
